import { HttpHeaders } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { Injector } from "@angular/core";
import { User, UserManager } from "oidc-client-ts";
import { environment } from "../../environments/environment";
import { SessionService } from "src/app/services/session.service";
import { ConfigService } from "./config.service";

@Injectable()
export class AuthService {
  mgr: UserManager;
  userLoadededEvent: EventEmitter<User> = new EventEmitter<User>();
  currentUser: User;
  loggedIn = false;
  public isGame = false; 

  authHeaders: HttpHeaders;
  private authHeaderValue: string;

  constructor(private readonly inj: Injector, private config: ConfigService) {}

  async setupAuth() {
    const session = this.inj.get(SessionService);
    const originalPath = sessionStorage.getItem('originalPath') || '';
    console.log("originalpath",originalPath);
    let siteUrl = window.location.origin;
    //console.log("siteurl",siteUrl);
    //console.log("startup session.getToken() in auth service",session.getToken());
    //if (!session.getToken()) {
      let vspConfig;
    if (
      (!originalPath.includes('admin')) ||
      environment.localvsp
    ) {
          
      try {
        //console.log("calling getauthcongigs");
        vspConfig = await this.config.getAuthConfigs();
        this.isGame = false;
        console.log("vspconfig, isgame",vspConfig, this.isGame);  
      } catch (e) {
        console.log('Failed to fetch remote configs. Using local.', e);
        vspConfig = this.config.getConfigObject('oauthSettingsVSP');
      }
    }
    else{
      try {
        console.log("calling getAuthConfigsGAME");
        vspConfig = await this.config.getAuthConfigsGAME();
        this.isGame = true;
        console.log("vspconfig GAME, isgame",vspConfig, this.isGame);  
      } catch (e) {
        console.log('Failed to fetch remote configs. Using local.', e);
        vspConfig = this.config.getConfigObject('oauthSettingsGAME');
      }
    }
      vspConfig.silent_redirect_uri = siteUrl + "/silent-renew.html";
      vspConfig.end_session_endpoint = siteUrl;
      console.log("vsp login");

      this.mgr = new UserManager(vspConfig);
    
  //}

    if (this.mgr) {
      this.mgr
        .getUser()
        .then((user) => {
          if (user && !user.expired) {
            this.loggedIn = true;
            this.currentUser = user;
            this.userLoadededEvent.emit(user);
          } else {
            this.loggedIn = false;
          }
        })
        .catch((err) => {
          this.loggedIn = false;
        });

      this.mgr.events.addUserLoaded((user) => {
        this.currentUser = user;
        if (!environment.production) {
          console.log("authService addUserLoaded", user);
        }
      });
    }
  }

  beginLogin(): Promise<any> {
    console.log(
      "beginLogin called, mgr settings",
      this.mgr.settings.redirect_uri
    );
    return this.mgr.getUser().then((val) => {
      if (val == null || val.expired) {
        sessionStorage.setItem('originalPath', window.location.pathname);
        return this.mgr
          .signinRedirect()
          .then(function (user) {
            console.log("begin login user", user);
            console.log("signinRedirect done");
            return null;
          })
          .catch(function (err) {
            console.log(err);
          });
      }

      this._setAuthHeaders(val);
    });
  }

  finishLogin(code: string, state: string): Promise<any> {
    let service = this;
    return this.mgr.signinRedirectCallback().then(function (user) {
      console.log("user in finish login", user);
      if (user == null) {
        throw new Error("AUTH FAILED");
      }
      console.log("SSO USER", user);
      service._setAuthHeaders(user);
      return null;
    });
  }

  getUser() {
    this.mgr
      .getUser()
      .then((user) => {
        console.log("got user", user);
        this.currentUser = user;
        this.userLoadededEvent.emit(user);
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  removeUser() {
    this.mgr
      .removeUser()
      .then(() => {
        this.userLoadededEvent.emit(null);
        console.log("user removed");
      })
      .catch(function (err) {
        console.log(err);
      });
  }

  _setAuthHeaders(user: any) {
    this.authHeaders = new HttpHeaders();
    this.authHeaderValue = "Bearer " + user.id_token;
    this.authHeaders.append("Authorization", this.authHeaderValue);
    this.authHeaders.append("Content-Type", "application/json");
    this.authHeaders.append("sourceid", "2");
  }

  public _setRequestOptions(options?: HttpHeaders): HttpHeaders {
    if (options) {
      options.append("Authorization", this.authHeaders.get("Authorization"));
    } else {
      options = this.authHeaders;
    }

    console.log("request options", options);
    return options;
  }

  public getAuthHeader() {
    return this.authHeaderValue;
  }

  public signout() {
    this.mgr.getUser().then((user) => {
      console.log("USER IN SIGNOUT", user);
      this.mgr
        .signoutRedirect({ id_token_hint: user.id_token })
        .then((result) => {
          console.log("sign out redirect result", result);
        });
    });
  }
}
